import { getStorage } from "./storage";
import { isAppAccessUserFn } from "../../utils/users";
import defaultValuesOld from "../scenarios/edu-scenarios";

export const getOrgApp = async () => {
  let orgApp = [];
  let isAppAccessUser = isAppAccessUserFn();
  const orgArray = await getStorage("ORGANIZATIONS");
  orgArray &&
    orgArray.forEach((org) => {
      let orgId = org.ID;
      let orgName = org.Name;
      let depts = [];
      const deptsArray = isAppAccessUser
        ? [defaultValuesOld().departments[2]]
        : org.Departments;

      deptsArray.forEach((dept) => {
        let id = dept.ID;
        let code = dept.DepartmentCode;
        let apps = [];
        dept.Applications.forEach((app) => {
          apps.push({
            appName: app.Name,
            appId: app.ID,
            appEnv: app.Environments[0].Name,
            appEnvId: app.Environments[0].ID,
            appDeptId: dept.ID,
            appOrgId: org.ID,
          });
        });
        let accounts = [];
        dept.Accounts.forEach((account) => {
          accounts.push({
            accountName: account.AccountName,
            accountNumber: account.AccountNumber,
          });
        });
        depts.push({
          deptId: id,
          deptCode: code,
          deptApps: apps,
          deptAccounts: accounts,
        });
      });
      orgApp.push({ orgId: orgId, orgName: orgName, depts: depts });
    });
  return orgApp;
};
